<template>

    <div>

        <h4>{{ $t('elementTypes.headings.image') }}</h4>

        <configure-property :show="data.getImageIsManipulable()">

            <div class="file-upload">

                <input :id="'file-input-' + data.getId()" type="file" @change="imageSelected">

                <label :for="'file-input-' + data.getId()">

                    <i class="material-icons">
                        file_upload
                    </i>

                    <span>Wählen Sie ein Bild...</span>

                </label>

                <div class="filename">{{ data.getFilename() }}</div>

            </div>

            <p v-if="isDpiHighEnough" style="color: orangered; display: flex; align-items: center; justify-content: space-between"><i class="material-icons">error</i> Das Bild sollte mind. eine DPI von {{data.getCanvas()._dpi}} aufweisen.</p>

            <div class="image-preview">
                <img :src="data.getImageContent()" v-if="data.getImageContent()" alt="">
            </div>

        </configure-property>

        <configure-property :label="$t('configurationProperty.height')" :show="data.getHeightIsManipulable() && data.getShowHeightDirectInputField()">
            <input type="number" :value="data.getScaledHeightInMm()" @input="eventHeightModified">
        </configure-property>

        <configure-property :label="$t('configurationProperty.width')" :show="data.getWidthIsManipulable() && data.getShowWidthDirectInputField()">
            <input type="number" :value="data.getScaledWidthInMm()" @input="eventWidthModified">
        </configure-property>

        <configure-property :label="$t('configurationProperty.top')" :show="data.getTopIsManipulable() && data.getShowTopDirectInputField()">
            <input type="number" :value="data.getTopBoundingBoxInMm()" @input="eventTopModified">
        </configure-property>

        <configure-property :label="$t('configurationProperty.left')" :show="data.getLeftIsManipulable() && data.getShowLeftDirectInputField()">
            <input type="number" :value="data.getLeftBoundingBoxInMm()" @input="eventLeftModified">
        </configure-property>

        <configure-property :label="$t('configurationProperty.angle')" :show="data.getAngleIsManipulable() && data.getShowAngleDirectInputField()">
            <input type="number" :value="roundAngle" @input="eventAngleModified">
        </configure-property>

    </div>

    <!-- <div class="print-elements">

        <label>
            Höhe
            <input type="number" :value="data.getScaledHeight()" @input="eventHeightModified">
        </label>

        <label>
            Breite
            <input type="number" :value="data.getScaledWidth()" @input="eventWidthModified">
        </label>

        <label>
            Drehen
            <input type="number" :value="data.getAngle()" @input="eventAngleModified">
        </label>

    </div> -->

</template>

<script>
    import requestHelper from "./../../api/requestHelper";
    import ConfigureProperty from "./ConfigureProperty";
    import i18n from "../../translation/i18n";

    export default {
        name: "ImageCanvasObject",
        components: {
            ConfigureProperty
        },
        i18n,
        data: () => ({
            choosenImage: null,
            mimeTypesNeedUploadFirst: [ 'application/postscript', 'application/pdf' ],
            fileExtensionsNeedUploadFirst: [ 'ai', 'eps', 'pdf' ],
            directUseMimeTypes: [ 'image/png', 'image/jpeg' ]
        }),
        props: {
            data: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {

            roundAngle() {
                return Math.round(this.data.getAngle());
            },

            isDpiHighEnough() {

                const dpiHeight = (this.data.getHeight() * 25.4) / this.data.getCanvas().convertPixelToMm(this.data.getScaledHeight());

                const dpiWidth = (this.data.getWidth() * 25.4) / this.data.getCanvas().convertPixelToMm(this.data.getScaledWidth());

                return !( dpiHeight >= this.data.getCanvas().getDpi() && dpiWidth >= this.data.getCanvas().getDpi() );
            }

        },
        methods: {
            eventHeightModified(e) {
                this.data.setScaledHeightInMm(parseFloat(e.target.value));
                this.data.setScaledWidthInMm(parseFloat(e.target.value) / this.data.getImageRatio());
                this.data.getCanvas().render();
            },
            eventWidthModified(e) {
                if (parseFloat(e.target.value) > 0) {
                    this.data.setScaledWidthInMm( parseFloat(e.target.value) );
                    this.data.setScaledHeightInMm(parseFloat(e.target.value) * this.data.getImageRatio());
                    this.data.getCanvas().render();
                }
            },
            eventTopModified(e) {
                this.data.setTopBoundingBoxInMm( parseFloat(e.target.value) );
                this.data.getCanvas().render();
            },
            eventLeftModified(e) {
                this.data.setLeftBoundingBoxInMm( parseFloat(e.target.value) );
                this.data.getCanvas().render();
            },
            async eventAngleModified(e) {
                this.data.setAngle(+ e.target.value);
                await this.data.getCanvas().render();
                this.data.setLeftBoundingBoxInMm( this.data.getLeftBoundingBoxInMm() );
                await this.data.getCanvas().render();
            },
            async imageSelected(e) {

                this.choosenImage = e.target.files[0];

                if (this.directUseMimeTypes.includes( this.choosenImage.type )) {
                    const fileReader = new FileReader();

                    await fileReader.addEventListener('load', async event => {

                        this.data.allowResizing();

                        this.data.setFilename(this.choosenImage.name);

                        this.data.setImageContent( event.target.result );

                        await this.data.createImageStore();

                        this.data.getCanvas().render();

                    });

                    fileReader.readAsDataURL(e.target.files[0]);
                } else if (this.mimeTypesNeedUploadFirst.includes( this.choosenImage.type )) {

                    const splitFileName = this.choosenImage.name.split('.');
                    const fileExtension = splitFileName[splitFileName.length - 1];

                    if (this.fileExtensionsNeedUploadFirst.includes( fileExtension )) {

                        console.log('upload for convert data');

                        const data = new FormData();
                        data.append('file', e.target.files[0], this.choosenImage.name);

                        const response = await requestHelper.requestApiRoute(
                            'post',
                            `/image/original`,
                            data,
                            error => console.log(error),
                            {
                                headers: {
                                    'Content-Type': `multipart/form-data`,
                                }
                            }
                        );

                        this.data.allowResizing();

                        this.data.setFilename(this.choosenImage.name);

                        this.data.setImageUrl(
                            requestHelper.createUrl(`/image/${response.id}`)
                        );

                        await this.data.createImageStore();

                        this.data.getCanvas().render();

                    }

                } else {
                    alert('Das Format der gewählten Datei wird nicht unterstützt.');
                }

            }
        },
        mounted() {
            if (this.hasOwnProperty('mounted')) {
                this.mounted();
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    h4 {
        color: $blue-color;
        margin: 0;
        margin-bottom: 10px;
    }

    .print-elements {
        background-color: #ffffff;
        margin-bottom: 10px;
        padding: 10px;
    }

    .print-elements strong {
        color: #004B92;
        font-weight: normal;
    }

    .file-upload {

        width: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 5px;

        input {
            display: none;
        }

        label {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background-color: lighten($grey-font, 50);
            color: $grey-font;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;

            &:hover {
                cursor: pointer;
                background-color: lighten($grey-font, 40);
            }
        }

        div.filename {
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #ffffff;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }

    }

    .image-preview {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        background-color: white;
        margin: 2rem 0;

        img {
            padding: 20px 0;
            max-width: 70%;
            max-height: 200px;
        }
    }

    label.configure-property {
        display: flex;
        flex-direction: column;
        margin-bottom: .5rem;

        span {
            color: $blue-color;
            font-weight: lighter;
        }

        input {
            box-sizing: border-box;
            border-radius: 5px;
            width: 100%;
            border: 1px solid $grey-font;
            background-color: white;
            padding: 0.5rem;

            &:invalid {
                border: 1px solid $grey-font;
                box-shadow: none;
            }
        }
    }

</style>